var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[(_vm.videoInfo.i)?_c('div',{staticClass:"video-click-area clickable",style:(_vm.videoAreaStyle)}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }